import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { pendingInvitesPropTypes } from 'app/selectors/machines';
import { renderMachineCell } from './machine-cell';

import './invites.less';

const Invites = (props) => {
  const rows = _.map(props.pendingInvites, (invite, index) => (
    <tr key={index}>
      <td className='name'>
        {invite.email}
      </td>
      <td>
        {renderMachineCell(invite.machines)}
      </td>
    </tr>
  ));

  return (
    <div className='Invites'>
      <div className='tableWrapper'>
        <table className='styledTable striped'>
          <thead>
            <tr className='header label'>
              <th>Email</th>
              <th>Access To...</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    </div>
  );
};

Invites.propTypes = {
  pendingInvites: PropTypes.arrayOf(PropTypes.shape(pendingInvitesPropTypes)).isRequired,
};

export default Invites;



// WEBPACK FOOTER //
// ./app/components/settings/invites.jsx